import {API} from "aws-amplify";
import {awsApiName} from "../../shared/amplify/amplify-utils";
import {CreateSubscriptionResponse} from "../../entity/resource/create-subscription-response";
import {RequestBody} from "../../entity/core/request-body";
import {SubscriptionsResponse} from "../../entity/resource/subscriptions-response";
import {CancelSubscriptionResponse} from "../../entity/resource/cancel-subscription-response";
import {TokenPackageResponse} from "../../entity/resource/token-package-response";
import {CreateCheckoutSessionResponse} from "../../entity/resource/create-checkout-session-response";
import {ConfirmPurchaseResponse} from "../../entity/resource/confirm-purchase-response";
import {TokenBalanceResponse} from "../../entity/resource/token-balance-response";
import {CostTypesResponse} from "../../entity/resource/cost-types-response";

export default class SubscriptionAgent {

    validateSubscriptions = async (organizationId: string): Promise<boolean> => {
        return await API.get(awsApiName, `/organizations/${organizationId}/billing/subscriptions/validate`, {});
    }

    getSubscriptions = async (organizationId: string): Promise<SubscriptionsResponse | []> => {
        return await API.get(awsApiName, `/organizations/${organizationId}/billing/subscriptions`, {});
    }

    subscribe = async (organizationId: string, isAnnual: boolean, requestBody: RequestBody): Promise<CreateSubscriptionResponse> => {
        return await API.post(awsApiName, `/organizations/${organizationId}/billing/subscriptions/products/${process.env.REACT_APP_SUBSCRIPTION_PRODUCT_ID}/prices/${isAnnual ? process.env.REACT_APP_ANNUALLY_SUBSCRIPTION_PRICE_ID : process.env.REACT_APP_MONTHLY_SUBSCRIPTION_PRICE_ID}/create-subscription-checkout-session`, requestBody);
    }

    cancelSubscription = async (organizationId: string, subscriptionId: string): Promise<CancelSubscriptionResponse> => {
        return await API.post(awsApiName, `/organizations/${organizationId}/billing/subscriptions/${subscriptionId}/cancel`, {});
    }

    updatePaymentMethod = async (organizationId: string): Promise<CreateSubscriptionResponse> => {
        return await API.post(awsApiName, `/organizations/${organizationId}/billing/subscriptions/customer/update-payment-method`, {});
    }

    getTokenPackages = async (): Promise<TokenPackageResponse[]> => {
        return await API.get(awsApiName, `/billing/tokens/packages`, {});
    }

    createCheckoutSession = async (organizationId: string, packageId:string): Promise<CreateCheckoutSessionResponse> => {
        return await API.post(awsApiName, `/organizations/${organizationId}/billing/tokens/packages/${packageId}/create-checkout-session`, {});
    }

    confirmPurchase = async (organizationId: string, requestBody: RequestBody): Promise<ConfirmPurchaseResponse> => {
        return await API.post(awsApiName, `/organizations/${organizationId}/billing/tokens/confirm-purchase`, requestBody);
    }

    getTokenBalance = async (organizationId: string): Promise<TokenBalanceResponse> => {
        return await API.get(awsApiName, `/organizations/${organizationId}/billing/tokens/balance`, {});
    }

    getCostTypes = async (): Promise<CostTypesResponse[]> => {
        return await API.get(awsApiName, `/billing/tokens/cost-types`, {});
    }
}